const ClaimsWrapper = {
  Heading: "Claims"
};

export default ClaimsWrapper;
